var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevel1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1459 10.7586L22.0468 18.0691C22.1 18.504 21.912 18.9286 21.5538 19.1922C20.3125 20.0928 17.0638 22 11.8644 22C6.66507 22 3.76748 20.1749 2.67157 19.3018C2.34883 19.045 2.18214 18.6512 2.22115 18.2472L2.95885 10.5326C2.98722 10.2313 2.78506 9.95393 2.4836 9.87517C0.717382 9.41634 -0.836038 7.02288 0.508131 4.81774C2.44813 1.63673 7.19706 3.35907 7.19706 3.35907C7.19706 3.35907 8.55542 0 12.1162 0C15.677 0 16.9503 3.39331 16.9503 3.39331C16.9503 3.39331 21.607 2.22226 23.398 4.85541C24.7954 6.90988 23.5754 9.63549 21.6283 10.084C21.3126 10.156 21.1069 10.447 21.1459 10.7586Z",
    fill: "#CCCC52"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel1);
export default __webpack_public_path__ + "static/media/level1.1dce76dd24ae751eb1e6d5e9a38a44e6.svg";
export { ForwardRef as ReactComponent };